<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">物资出入库记录</div>
      <el-form class="zj-search-form clear" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="开始日期">
          <el-date-picker placeholder="选择日期" v-model="beginDate" style="width:30rem" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker placeholder="选择日期" v-model="endDate" style="width:30rem" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-input v-model="warehouseName" style="width:30rem"></el-input>
        </el-form-item>
        <el-form-item label="物资名称">
          <el-input v-model="materialName" style="width:30rem"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <el-table
        :data="tableData"
        ref="multipleTable"
        @selection-change="selectionChange"
        border
        style="width: 100%"
        height="100%"
      >
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="materialName" label="物资名称"></el-table-column>
        <el-table-column
          prop="materialType"
          label="物资类型"
          :formatter="materialType"
          align="center"
        >
          <template slot-scope="scope">
            <span v-for="item in options" :key="item.id">
              <span v-if="item.code == scope.row.materialType">{{ item.value }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="存放仓库" align="center"></el-table-column>
        <el-table-column prop="InNum" label="入库" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='2'">{{ scope.row.operationNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutNum" label="出库" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='1'">{{ scope.row.operationNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operationDate"
          label="出入库时间"
          :formatter="formatDate"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column prop="receiver" label="领取人" align="center"></el-table-column>
        <el-table-column prop="operationPerson" label="操作人" align="center"></el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import { materialInoutList, materialInoutRemove } from "@/api/src/emergency_materialInout"
import { getDictionary } from '@/api/src/emergency_common'
export default {
  name: "ZjMaterialResourcerecordlist",
  controller: "UI",
  action: "MaterialResourcerecordlist",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      beginDate: null,
      endDate: null,
      warehouseName: "",
      materialName: "",
      selectData: null,
      options: [],
      MaterialTypeDic: [],
    };
  },
  created: function() {
    this.getDictionaryType();
    this.loading = true;
    this.loadingText = "加载中...";
    this.search();
  },
  mounted: function() {
  },
  methods: {
    // 获取物资类型数组
    getDictionaryType() {
      getDictionary('emergency_material_type')
        .then(res => {
          //物资类型
          this.options = res.data.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
     
      let searchInfo = {
        beginDate: this.beginDate,
        endDate:this.endDate,
        warehouseName: this.warehouseName,
        materialName: this.materialName,
        size: this.pageSize,
        current: this.currentPage
      };
      console.log(this.beginDate)
      this.loading = true;
      this.loadingText = "加载中...";
      materialInoutList(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    clearsearch() {
      (this.beginDate = null),
        (this.endDate = null),
        (this.warehouseName = ""),
        (this.materialName = "");
      this.search();
    },
    // 点击查询按钮
    onSearch() {
      if(!this.beginDate&& this.endDate){
        this.$message.info("请选择开始日期");
        return;
      }
      if(this.beginDate&& !this.endDate){
        this.$message.info("请选择结束日期");
        return;
      }
      if (new Date(this.endDate) < new Date(this.beginDate)) {
        this.$message.info("开始日期不能大于结束日期");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },

    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        materialInoutRemove({idList: row.id})
          .then(r => {
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
            this.loading = false;
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.MaterialTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>